import { useTranslation } from 'next-i18next';
import { usePrices } from '@/module/payment/hooks';
import { useCountryCode } from '@/shared/hooks';
import { useFirstPurchaseDiscount } from '@/shared/hooks/useFirstPurchaseDiscount';
import { useFeatureStrings } from '@/shared/plan/useFeatureStrings';
import { formatCurrencyPrice } from '@/shared/utils/currency';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import * as PricingCard from './PricingCard';
export const FreePricingCard = (props: PricingCard.PricingCardProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    className,
    ctaButtonText: ctaButtonTextProp,
    ctaButtonDisabled,
    onCtaButtonClick,
    footer
  } = props;
  const ctaButtonText = ctaButtonTextProp ?? t('common:pricing.free.startForFree');
  const {
    countryCode
  } = useCountryCode();
  const featureStrings = useFeatureStrings(countryCode);
  return <PricingCard.Container className={className} data-sentry-element="unknown" data-sentry-component="FreePricingCard" data-sentry-source-file="FreePricingCard.tsx">
      <PricingCard.TopSection data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx">
        <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx">
          <h2 className="text-heading-xl-extrabold text-alternative">Free</h2>
        </PricingCard.Header>
        <Price countryCode={countryCode} data-sentry-element="Price" data-sentry-source-file="FreePricingCard.tsx" />
        <PricingCard.Description data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx">
          {t('common:pricing.free.description')}
        </PricingCard.Description>
        <Button variant="outlined" intent="neutral" size="lg" className="mt-auto w-full" disabled={ctaButtonDisabled} onClick={onCtaButtonClick} data-sentry-element="Button" data-sentry-source-file="FreePricingCard.tsx">
          {ctaButtonText}
        </Button>
      </PricingCard.TopSection>

      <PricingCard.Divider data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx" />

      <PricingCard.BottomSection data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx">
        <PricingCard.FeatureTitles mainTitle={t('common:pricing.free.basicFeatures')} subTitle={t('common:pricing.free.limitedFeatures')} data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx" />
        <PricingCard.FeatureItemList items={featureStrings.FREE.normalFeatures} data-sentry-element="unknown" data-sentry-source-file="FreePricingCard.tsx" />
      </PricingCard.BottomSection>
      {footer}
    </PricingCard.Container>;
};
export const Price = ({
  countryCode
}: {
  countryCode: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    isEligible
  } = useFirstPurchaseDiscount();
  const {
    displayCurrency
  } = usePrices({
    countryCode,
    planType: 'BASIC'
  });
  if (countryCode === 'KR') {
    return <strong className={cn('text-display-sm-extrabold text-assistive', isEligible ? 'mt-[24px]' : 'mt-0')}>
        {t('common:pricing.free.free')}
      </strong>;
  }
  return <div className="flex h-[76.4px] flex-col justify-end" data-sentry-component="Price" data-sentry-source-file="FreePricingCard.tsx">
      <strong className="text-display-sm-extrabold text-assistive">
        {formatCurrencyPrice(0, displayCurrency)}
      </strong>
    </div>;
};